// French is the product default on both the web and mobile applications.
// Keep this value shared so Clerk, Expo and the web app never pick different
// languages when no preference has been stored yet.
export const DEFAULT_LANGUAGE = "fr";
export const LANGUAGE_STORAGE_KEY = "qubiq_language";

export const SUPPORTED_LANGUAGES = [
  { code: "fr", nativeLabel: "Français" },
  { code: "en", nativeLabel: "English" },
  { code: "es", nativeLabel: "Español" },
  { code: "de", nativeLabel: "Deutsch" },
  { code: "pt", nativeLabel: "Português" },
  { code: "it", nativeLabel: "Italiano" },
];

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map(
  (language) => language.code
);

export const isSupportedLanguage = (value) =>
  SUPPORTED_LANGUAGE_CODES.includes(String(value || "").toLowerCase());

export const normalizeToSupportedLanguage = (value) => {
  const normalized = String(value || "")
    .trim()
    .toLowerCase()
    .replace("_", "-");

  if (!normalized) return DEFAULT_LANGUAGE;

  const primary = normalized.split("-")[0];

  return isSupportedLanguage(primary) ? primary : DEFAULT_LANGUAGE;
};

export const getLanguageOption = (languageCode) =>
  SUPPORTED_LANGUAGES.find(({ code }) => code === normalizeToSupportedLanguage(languageCode)) ||
  SUPPORTED_LANGUAGES.find(({ code }) => code === DEFAULT_LANGUAGE);
